var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"imageButton",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{staticClass:"img",style:({ '--size': _vm.size + 'px' }),attrs:{"alt":_vm.altText,"src":require(`@/assets/${_vm.image}`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }